import { useEffect, useState } from 'react';
import { CarrotRight } from '../../shared/assets/carrot-right';
import { Logout } from '../../shared/assets/logout';
import { Button } from '../Button/Button';
import './IdlePopup.scss';
import { IdlePopupProps } from '../../shared/types/types';
import { useAuth0 } from '@auth0/auth0-react';

const IdlePopup = ({ show, onClose }: IdlePopupProps) => {
  // initialize logout countdown
  const secondsToAutomaticLogout = Number(
    process.env.REACT_APP_SECONDS_LEFT_BEFORE_IDLE_LOGOUT
  );

  const minutesToAutomaticLogout = Number(
    process.env.REACT_APP_MINUTES_LEFT_BEFORE_IDLE_LOGOUT
  );

  const [secondsToLogout, setSecondsToLogout] = useState<number>(
    secondsToAutomaticLogout
  );
  const [minutesToLogout, setMinutesToLogout] = useState<number>(
    minutesToAutomaticLogout
  );
  const addZero = secondsToLogout < 10 ? '0' : '';
  const { logout } = useAuth0();

  useEffect(() => {
    const updateCountdown = (
      secondsToLogout: number,
      minutesToLogout: number
    ) => {
      setSecondsToLogout(secondsToLogout - 1);
      if (secondsToLogout === 0) {
        setMinutesToLogout(minutesToLogout - 1);
        setSecondsToLogout(59);
      }
      if (secondsToLogout === 1 && minutesToLogout === 0) {
        logout({ returnTo: window.location.origin });
        onClose(true);
      }
    };

    while (secondsToLogout > 0 || minutesToLogout > 0) {
      const interval = setInterval(
        () => updateCountdown(secondsToLogout, minutesToLogout),
        1000
      );
      return () => {
        clearInterval(interval);
      };
    }
  }, [minutesToLogout, secondsToLogout, onClose, logout]);

  const handleIdleLogout = () => {
    logout();
    onClose(true);
  };

  const handleOnMouseOver = (event: any) => {
    event.stopPropagation();
  };

  if (!show) {
    return null;
  } else {
    return (
      <div
        className="idle-popup-container"
        onMouseMove={handleOnMouseOver}
      >
        <div className="idle-popup-parent">
          <span className="popup-header">Are you still there?</span>
          <span className="popup-body-text">
            You will be automatically logged out in
          </span>
          <span className="popup-countdown">
            {minutesToLogout}:{addZero}
            {secondsToLogout}
          </span>
          <div className="popup-buttons">
            <Button
              label="Log Out"
              className="logout-button"
              icon={<Logout fill="#0091b2" />}
              iconPlacement="left"
              onClick={() => handleIdleLogout()}
            />
            <Button
              className="continue-button"
              label="Continue"
              icon={<CarrotRight />}
              iconPlacement="right"
              onClick={() => onClose(true)}
            />
          </div>
        </div>
      </div>
    );
  }
};

export default IdlePopup;
